import React from "react";
import Loader from "../../../../../components/Loader";
import Page from "../../../../../components/Page";
import HTTPManager from "../../../../../utils/httpRequestManager";
import TableView from "../../../../../components/table/tableView";
import { toast, ToastContainer } from 'react-toastify';
import Iconify from "../../../../../components/Iconify";
import FormManager from "../../../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack} from '@mui/material';

import { checkButtonAccess } from "../../../../../utils/protector";
import FButton from "../../../../../components/formComponents/components/button";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class TerminalSettings extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            terminalsettings:[],
            addForm: false,
            selectedtmsetting:{},
            viewTable: true,
            columns: [ 
                {
                    field: 'terminalMerchantId',
                    headerName: 'Merchant ID',
                    minWidth:200,
                    editable: false,
                },
                {
                    field: 'terminalurl',
                    headerName: 'URL',
                    minWidth:300,
                    editable: false,
                },
                {
                    field: 'hsn',
                    headerName: 'HSN',
                    minWidth:200,
                    editable: false,
                },
                {
                    field: 'paymentoption',
                    headerName: 'Payment Option',
                    minWidth:200,
                    editable: false,
                },
                {
                    field:'',
                    headerName:'Actions', 
                    minWidth:300,
                    editable: false,
                    renderCell: ()=>(<FButton
                    variant="contained"
                    size="small"
                    onClick={this.handleToggleView}
                    label={this.state.selectedtmsetting.hasOwnProperty('terminalMerchantId') ? "Edit" : "Add"}
                    />)
                }
            ]
            
        }
        this.handleCloseform = this.handleCloseform.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.handleToggleView = this.handleToggleView.bind(this);
    }
    
    componentDidMount(){
        this.setState({schema: schema},()=>{
            this.reloadData()
        })
    }

    reloadData(){
        this.httpManager.postRequest(`merchant/terminalsettings/get`, {merchantId: this.props.merchant.merchantId}).then(response=>{
            let settmsetting={};
            settmsetting.merchantId = this.props.merchant.merchantId
            if(response.data.length > 0){
                settmsetting = {...settmsetting, ...response.data[0]}
            } else {
                settmsetting.id = () => Math.floor(Math.random() * 3)
            }
            this.setState({selectedtmsetting: settmsetting}, ()=>{
                let tmArray = []
                tmArray.push(settmsetting)
                this.setState({terminalsettings: tmArray})
            });
        });
    }

    handleToggleView(){
        this.setState({isLoading: true}, () => {
            if (this.state.selectedtmsetting.hasOwnProperty('terminalMerchantId')) {
                this.openEdit(this.state.selectedtmsetting, ()=>{
                    this.setState({addForm: true})
                })
            } else {
                this.openAdd(()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }

    handleCloseform(){
        this.setState({addForm: false})
    }

    // openEdit(data, callback){
    //     var schema = Object.assign({}, this.state.schema);
    //     var properties = Object.assign([], this.state.schema.properties);
    //     var props=[];
    //     properties.forEach((field,i)=>{
    //             field.value = data[field.name];
    //             props.push(field);
    //         if(i === properties.length-1){
    //             props.push({
    //                 "component":"TextField", 
    //                 "type": "hidden", 
    //                 "minLength": 1,
    //                 "maxLength": 100,
    //                 "grid":6,
    //                 "name":"merchantId",
    //                 "label":"Merchant ID",
    //                 "placeholder":"Merchant ID",
    //                 "value":this.props.merchant.merchantId
    //               })
    //             schema.properties = props;
    //             schema.force=true; 
    //             this.setState({schema: schema,selectedtmsetting: data},()=>{
    //                 this.setState({isLoading: false}, ()=>callback())
    //             })
    //         }
    //     })
    // }

    // openAdd(callback){
    //     this.setState({schema: schema,selectedtmsetting: {}},()=>{
    //         var schemaobj = Object.assign({}, schema);

    //         var properties = Object.assign([], this.state.schema.properties);
    //         var props=[];
    //         properties.forEach((field,i)=>{
    //             if (field.name === 'paymentoption') {
    //                 field.value = 'NT'
    //             }
    //             props.push(field);
    //             if(i === properties.length-1){
    //                 props.push({
    //                     "component":"TextField", 
    //                     "type": "hidden", 
    //                     "minLength": 1,
    //                     "maxLength": 100,
    //                     "grid":6,
    //                     "name":"merchantId",
    //                     "label":"Merchant ID",
    //                     "placeholder":"Merchant ID",
    //                     "value":this.props.merchant.merchantId
    //                   })
    //                 schemaobj.properties = props;
    //                 schemaobj.force=true;
    //             }
    //         });
    //         this.setState({schema:schemaobj}, ()=>{
    //             this.setState({isLoading: false}, ()=>callback()) 
    //         })
    //     })
    // }

    openEdit(data, callback) {
    // Clone schema deeply
    const schema = { ...this.state.schema };
    const properties = [...this.state.schema.properties]; // clone array safely

    // Map through fields and assign values
    const updatedProperties = properties.map(field => ({
        ...field,
        value: data[field.name] ?? ""
    }));

    // Add hidden merchantId field only once
    updatedProperties.push({
        component: "TextField",
        type: "hidden",
        minLength: 1,
        maxLength: 100,
        grid: 6,
        name: "merchantId",
        label: "Merchant ID",
        placeholder: "Merchant ID",
        value: this.props.merchant.merchantId
    });

    // Update schema
    schema.properties = updatedProperties;
    schema.force = true;

    // Update state only once
    this.setState(
        { schema, selectedtmsetting: data, isLoading: false },
        () => {
            if (typeof callback === "function") {
                callback();
            }
        }
    );
}


openAdd(callback) {
    // Clone base schema safely
    const schemaCopy = { ...schema };
    const properties = [...schemaCopy.properties];

    // Prepare updated properties
    const updatedProperties = properties.map(field => {
        // Clone field & assign value conditionally
        return {
            ...field,
            value: field.name === "paymentoption" ? "NT" : ""
        };
    });

    // Add hidden merchantId field once
    updatedProperties.push({
        component: "TextField",
        type: "hidden",
        minLength: 1,
        maxLength: 100,
        grid: 6,
        name: "merchantId",
        label: "Merchant ID",
        placeholder: "Merchant ID",
        value: this.props.merchant.merchantId
    });

    // Update schema object
    const newSchema = {
        ...schemaCopy,
        properties: updatedProperties,
        force: true
    };

    // Single setState call
    this.setState(
        {
            schema: newSchema,
            selectedtmsetting: {},
            isLoading: false
        },
        () => {
            if (typeof callback === "function") callback();
        }
    );
}

    render(){
        return <Page title="Terminal Settings | Astro POS">
                {this.state.isLoading && <Loader show={this.state.isLoading} />}
                <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

        {!this.state.addForm && (
            <Container maxWidth="xl">
            <Card>
            <TableView
            data={this.state.terminalsettings} 
            columns={this.state.columns}
            />
            </Card>

            <Box sx={{ width: '100%' }}> 
                <Grid container spacing={7}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <FButton
                     variant="contained"
                     label="Close"
                     size="large"
                     onClick={()=>this.props.closeForm()}
                     />
                </Grid>
            </Box>
            </Container>
        )}

        {this.state.addForm && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={4}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager
                            formProps={this.state.schema}
                            closeForm={this.handleCloseform}
                            reloadData={()=>{this.setState({addForm: false}, ()=>{this.reloadData()})}}
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}
        </Page>
    }
}